var isMobile = false;
 if( /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || document.documentElement.clientWidth <= 769 ) {
    isMobile = true;
}
 $(document).ready(function () {
    $('#registroForm').on('submit', function (e) {
      e.preventDefault();

      // Limpiar errores anteriores
      $('input').removeClass('input-error');

      var nombre = $.trim($('input[name="name"]').val());
      var apellido = $.trim($('input[name="lastname"]').val());
      var email = $.trim($('input[name="email"]').val());

      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      var hasError = false;

      // Validar nombre
      if (nombre === '') {
        $('input[name="name"]').addClass('input-error');
        hasError = true;
      }

      // Validar apellido
      if (apellido === '') {
        $('input[name="lastname"]').addClass('input-error');
        hasError = true;
      }

      // Validar email
      if (email === '' || !emailRegex.test(email)) {
        $('input[name="email"]').addClass('input-error');
        hasError = true;
      }

      if (hasError) return;

      var formData = $(this).serialize();
      $('.mgmessage').html('Espere un momento por favor...');      
      $.ajax({
        type: 'POST',
        url: 'https://dev.socialpro.mx/ne_klaviyo/create_update_badbunny.php',
        data: formData,
        success: function (response) {
          window.location.href = "https://www.newera.mx/pages/gracias-por-suscribirte";          
        },
        error: function (error) {
          console.error('Error al enviar los datos', error);
        }
      });
    });
  });

(function(){
  // Fecha objetivo
  const target = new Date(2025, 11, 04, 12, 0, 0); // Agosto = 7 -> inicia de 0 a 11 el conteo de los meses
 
  // Elementos
  const $days = document.getElementById('days');
  const $hours = document.getElementById('hours');
  const $minutes = document.getElementById('minutes');
  const $seconds = document.getElementById('seconds');
  const $container = document.getElementById('countdown');

  // Formatear con 2 dígitos
  function pad(n){ return n < 10 ? '0' + n : String(n); }

  function update(){
    const now = new Date();
    let diff = target - now;

    if (diff <= 0){
      $days.textContent = '00';
      $hours.textContent = '00';
      $minutes.textContent = '00';
      $seconds.textContent = '00';
      return false;
    }

    // Cálculos
    const totalSeconds = Math.floor(diff / 1000);

    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    // Mostrar valores
    $days.textContent = pad(days);
    $hours.textContent = pad(hours);
    $minutes.textContent = pad(minutes);
    $seconds.textContent = pad(seconds);

    return true;
  }

  update();

  let intervalId = setInterval(function(){
    if (!update()) {
      clearInterval(intervalId);
      $container.classList.add('ended');
    }
  }, 1000);
})();
